<template>
  <div class="bg-animation">
    <div class="left">
      <img class="left__img" src="../assets/bg-left.png" alt="">
      <i class="iconfont iconbianzu10beifen2 icon--pc"></i>
      <i class="iconfont iconzhuanzhang-2beifen3 icon--exchange"></i>
      <i class="iconfont iconbianzu8beifen2 icon--card"></i>
      <i class="iconfont iconbianzu4 icon--mobile"></i>
    </div>
    <div class="mid">
      <div class="mid__img__wrapper" />
      <div class="mid__img__wrapper cover" />
    </div>
    <div class="right">
      <img class="right__img" src="../assets/bg-right.svg" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: 'BgAnimation',
};
</script>

<style lang="scss" scoped>
  $duration: 2s;
  .bg-animation {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    padding-left: 90px;
    padding-right: 127px;
    display: flex;
  }

  .left {
    position: relative;
    padding-bottom: 60px;
  }

  .left__img {
    /*width: 360px;*/
    height: 30vh;
  }

  .icon--pc {
    position: absolute;
    top: 0;
    left: -30px;
    font-size: 40px;
    animation: active $duration;
    animation-fill-mode: forwards;
  }

  .icon--exchange {
    position: absolute;
    top: -14px;
    right: -30px;
    font-size: 34px;
    animation: active $duration;
    animation-fill-mode: forwards;
  }

  .icon--card {
    position: absolute;
    top: 150px;
    right: -40px;
    font-size: 34px;
    animation: active $duration;
    animation-fill-mode: forwards;
  }

  .icon--mobile {
    position: absolute;
    top: 150px;
    right: -160px;
    font-size: 50px;
    animation: active-mobile $duration;
    animation-fill-mode: forwards;
  }

  .mid {
    flex: 1;
    position: relative;
  }

  .mid__img__wrapper {
    position: absolute;
    right: 0;
    left: 0;
    height: 100%;
    background-image: url("../assets/bg-line.svg");
    background-repeat: no-repeat;
    background-clip: content-box;
    background-size: 100%;
    background-position-y: 60px;
    transition: padding 3s;
    animation: hid $duration linear;
    animation-fill-mode: forwards;
    &.cover {
      background-image: url("../assets/bg-line-dark.svg");
      animation: cover $duration linear;
    }
  }

  .mid__img {
    width: 100%;
  }

  .right__img {
    margin-left: 30px;
    height: 28vh;
    margin-top: 60px;
  }

  @keyframes active-mobile {
    0% {
      color: #000;
    }

    79% {
      color: #000;
    }

    80% {
      color: rgba(94, 207, 197, 1);
    }

    100% {
      color: rgba(94, 207, 197, 1);
    }
  }

  @keyframes active {
    0% {
      color: #000;
    }

    99% {
      color: #000;
    }

    100% {
      color: rgba(94, 207, 197, 1);
    }
  }

  @keyframes cover {
    0% {
      padding-left: 100%;
    }
    100% {
      padding-left: 0;
    }
  }

  @keyframes hid {
    0% {
      padding-right: 0;
    }
    100% {
      padding-right: 100%;
    }
  }
</style>
